import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const DigilockerInitializeInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-folder-open', title: 'Digilocker Initialize', subtitle: 'Start a new Digilocker session for document retrieval' }}
        fields={[
            { name: 'full_name', label: 'Full Name', icon: 'pi-user', placeholder: 'Enter full name', maxLength: 100, autoCapitalize: 'words' },
            { name: 'mobile_number', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'user_email', label: 'Email', icon: 'pi-envelope', placeholder: 'user@example.com', maxLength: 100, htmlType: 'email', inputMode: 'email', autoCapitalize: 'none', spellCheck: false,
              regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, regexError: 'Enter a valid email' },
            { name: 'expiry_minutes', label: 'Expiry (minutes)', icon: 'pi-clock', placeholder: '30', maxLength: 4, inputMode: 'numeric', numeric: true, mono: true, required: false, colClass: 'col-12 md:col-4' },
            { name: 'redirect_url', label: 'Redirect URL', icon: 'pi-link', placeholder: 'https://your-app.com/callback', maxLength: 300, autoCapitalize: 'none', spellCheck: false, required: false, colClass: 'col-12 md:col-8' },
            { name: 'state', label: 'State Token', icon: 'pi-shield', placeholder: 'Optional state token', maxLength: 100, required: false, colClass: 'col-12 md:col-6' },
        ]}
        endpoint={{
            path: '/surepass/digilocker/initialize',
            bodyMapper: (v, sid) => ({
                data: {
                    prefill_options: { full_name: v.full_name.trim(), mobile_number: v.mobile_number, user_email: v.user_email.trim() },
                    ...(v.expiry_minutes ? { expiry_minutes: parseInt(v.expiry_minutes, 10) } : {}),
                    ...(v.redirect_url ? { redirect_url: v.redirect_url.trim() } : {}),
                    ...(v.state ? { state: v.state.trim() } : {}),
                },
                api_provider_service_id: parseInt(sid, 10),
            }),
        }}
        consentReportType="digilocker-initialize"
        submitLabel="Initialize Digilocker"
        successSummary="Digilocker initialized"
        errorSummary="Initialization failed"
        confirmHeader="Confirm Digilocker initialization"
        confirmAcceptLabel="Yes, initialize"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Digilocker Session', icon: 'pi-folder-open' }}
    />
);

export default DigilockerInitializeInputComponent;
